import { useState, useEffect, useContext, useRef, useMemo } from 'react'
import ContextStates from '../../context/ContextStates'
import axios from 'axios';
import { Url } from '../Url';
import { useNavigate } from 'react-router-dom';

import ReactToPrint from 'react-to-print';
import { FaPrint } from 'react-icons/fa'
import logo from '../../assets/izzyLogo.jpg'

// Helpers
const formatARS = (n) =>
    Number(n || 0).toLocaleString('es-AR', {
        style: 'currency',
        currency: 'ARS',
        maximumFractionDigits: 2,
    });

const num = (v) => {
    if (v === null || v === undefined) return 0;
    const s = String(v).replace(/[^\d.,]/g, '').replace(',', '.');
    const n = parseFloat(s);
    return Number.isFinite(n) ? n : 0;
};

const FViewPedido = () => {
    const [total, setTotal] = useState(0)
    const [medios, setMedios] = useState([])
    const [medioPago, setMedioPago] = useState('1') // principal (o '7' = mixto)
    const [medio1, setMedio1] = useState('1')      // usado cuando es mixto
    const [medio2, setMedio2] = useState('')       // usado cuando es mixto
    const [importe1, setImporte1] = useState('')
    const [importe2, setImporte2] = useState('')
    const [procesando, setProcesando] = useState(false)
    const [entregado, setEntregado] = useState(false)
    const { pedidoSelected, idUsuario, setViewOpen, viewOpen } = useContext(ContextStates)
    const componentRef = useRef();
    const navigate = useNavigate();

    const isCombo = medioPago === '7'
    const i1 = num(importe1)
    const i2 = num(importe2)
    const suma = i1 + i2
    const restante = Math.max(0, Number(total) - suma)

    // traer medios
    useEffect(() => {
        const getMedios = async () => {
            const formData = new FormData()
            try {
                const results = await axios({
                    url: Url + 'api/listmediospago.php',
                    method: 'POST',
                    data: formData,
                })
                setMedios(results.data.results || []);
            } catch (e) {
                console.log(e)
            }
        }
        getMedios()
    }, [])

    // total
    useEffect(() => {
        let t = 0;
        if (pedidoSelected?.pedido && Array.isArray(pedidoSelected.pedido)) {
            pedidoSelected.pedido.forEach(element => {
                t += Number(element.monto || 0)
            });
            setTotal(t)
        }
    }, [pedidoSelected])

    // cuando cambia el modo de pago
    useEffect(() => {
        if (!isCombo) {
            // un solo medio: usar ese, total completo
            setMedio1(medioPago)
            setImporte1(String(total))
            setMedio2('')
            setImporte2('')
        } else {
            // mixto: limpiar importes; el usuario define ambos
            setImporte1('')
            setImporte2('')
            setMedio2('')
        }
    }, [medioPago, total, isCombo])

    // autocompletar restante en importe2 al editar importe1 (en mixto)
    useEffect(() => {
        if (isCombo) {
            if (importe1 !== '') {
                const rest = Math.max(0, Number(total) - num(importe1))
                setImporte2(rest === 0 ? '' : String(rest))
            } else {
                setImporte2('')
            }
        }
    }, [importe1, isCombo, total])

    const handleEntrega = async () => {
        try {
            setProcesando(true)
            // normalizo según modo
            let _medio1 = medio1
            let _medio2 = medio2
            let _importe1 = i1
            let _importe2 = i2

            if (!isCombo) {
                _medio1 = medioPago
                _importe1 = Number(total)
                _medio2 = ''
                _importe2 = 0
            } else {
                if (!_medio1) {
                    alert('Seleccioná el primer medio de pago.')
                    setProcesando(false); return;
                }
                if (suma !== Number(total)) {
                    alert('La suma de importes debe ser igual al total.')
                    setProcesando(false); return;
                }
                if (_importe2 > 0 && _medio1 === _medio2) {
                    alert('Elegí medios distintos si vas a usar dos importes.')
                    setProcesando(false); return;
                }
            }

            const formData = new FormData()
            formData.append("id", pedidoSelected.idpedido)
            formData.append("idusuario", idUsuario)
            formData.append('mediopago', medioPago)  // '7' si es mixto, otro id si no
            formData.append('medio1', _medio1 || '')
            formData.append('medio2', _medio2 || '')
            formData.append('total', String(total))
            formData.append('importe1', String(_importe1 || 0))
            formData.append('importe2', String(_importe2 || 0))

            const response = await axios({
                url: Url + 'api/entrega.php',
                method: 'POST',
                data: formData,
            })
            console.log(response)
            setEntregado(true)
        } catch (e) {
            console.log(e)
            alert('No se pudo confirmar la entrega')
        } finally {
            setProcesando(false)
        }
    }

    // deshabilitar confirmación si algo está mal
    const confirmDisabled = useMemo(() => {
        if (procesando) return true
        if (!isCombo) return false
        if (!medio1) return true
        if (suma !== Number(total)) return true
        if (num(importe2) > 0 && medio1 === medio2) return true
        return false
    }, [procesando, isCombo, medio1, medio2, suma, total, importe2])

    // Manejar el botón de volver según el contexto
    const handleVolver = () => {
        if (viewOpen) {
            // Si está abierto como modal, cerrar el modal
            setViewOpen(false)
        } else {
            // Si es navegación directa, volver a la pantalla anterior
            navigate("/pedidos", {
                replace: true,
            });
        }
    }

    return (
        <div ref={componentRef} className="w-full py-5 px-2 md:px-20 rounded-2xl">
            {/* Encabezado */}
            <div className='flex'>
                <div className='w-1/2 px-10'>
                    <p className='uppercase font-bold text-xl'>Factura</p>
                    <p className='font-bold text-lg'>Izzy Distribución</p>
                    <p className='text-sm'>4000 San Miguel de Tucumán</p>
                    <p className='text-sm'>Tel: (Pedidos/Reclamos) 381 364 9720</p>
                    <p className='text-sm'>Email: izzydistribuciones@gmail.com</p>
                </div>
                <div className='w-1/2 px-10'>
                    <img src={logo} className='h-32 float-right' alt="logo" />
                </div>
            </div>

            {/* Datos cliente */}
            <div className='flex flex-wrap'>
                <div className='w-full md:w-1/2 px-10'>
                    <p><span className='font-semibold'>Cliente:</span> {pedidoSelected.cliente}</p>
                    <p><span className='font-semibold'>Domicilio:</span> {pedidoSelected.domicilio}</p>
                    <p className='print:hidden'><span className='font-semibold'>Teléfono:</span> {pedidoSelected.telefono}</p>
                </div>
                <div className='w-full md:w-1/2 px-10'>
                    <p><span className='font-semibold'>Fecha de Pedido:</span> {new Date(pedidoSelected.fechapedido).toLocaleDateString("es-AR", { day: "2-digit", month: "2-digit", year: "numeric" })}</p>
                    <p><span className='font-semibold'>Hora de Pedido:</span> {pedidoSelected.horapedido}</p>
                </div>
            </div>

            {pedidoSelected.estado !== 7 ? (
                <>
                    {/* Selector principal de medio (incluye Mixto id=7) */}
                    <div className='bg-gray-50 rounded-lg p-3 sm:p-5 sm:w-1/2 mx-auto print:hidden'>
                        {(medios || []).map((item) => (
                            <label key={item.id} className="flex items-center gap-2 py-1">
                                <input
                                    type="radio"
                                    name="medioPago"
                                    value={item.id}
                                    checked={medioPago === item.id}
                                    onChange={() => setMedioPago(item.id)}
                                />
                                <span>{item.descripcion}</span>
                            </label>
                        ))}
                    </div>

                    {/* Si NO es mixto: resumen */}
                    {!isCombo && (
                        <div className='sm:w-1/2 mx-auto mt-4 rounded-lg border border-indigo-200 bg-indigo-50 p-4 print:hidden'>
                            <p className="font-bold mb-1">Medio Seleccionado</p>
                            <p className="mb-1">
                                {(() => {
                                    const m = (medios || []).find(x => x.id === medioPago);
                                    return m ? m.descripcion : `ID ${medioPago}`;
                                })()}
                            </p>
                            <p className="font-extrabold">Importe: {formatARS(total)}</p>
                            <p className="text-gray-600 text-sm mt-1">* Se enviará el total con este medio.</p>
                        </div>
                    )}

                    {/* Mixto: elegir medios y montos dinámicamente */}
                    {isCombo && (
                        <>
                            {/* Medio 1 */}
                            <div className='w-full mt-5 bg-blue-50 rounded-lg p-5 print:hidden'>
                                <p className='text-xl font-bold'>Medio de Pago 1</p>
                                <div className='rounded-lg pt-2 sm:w-1/2'>
                                    {(medios || [])
                                        .filter(item => item.id !== '7')
                                        .map((item) => (
                                            <label key={item.id} className="flex items-center gap-2 py-1">
                                                <input
                                                    type="radio"
                                                    name="medioPago1"
                                                    value={item.id}
                                                    checked={medio1 === item.id}
                                                    onChange={() => setMedio1(item.id)}
                                                />
                                                <span>{item.descripcion}</span>
                                            </label>
                                        ))}
                                    <label className="block text-gray-800 mt-3" htmlFor='importe1'>Importe Medio 1</label>
                                    <input
                                        type='text'
                                        className={`p-2 rounded border w-full ${i1 > Number(total) ? 'bg-red-100 border-red-300' : 'bg-white border-gray-300'}`}
                                        value={importe1}
                                        id="importe1"
                                        onChange={(e) => setImporte1(e.target.value)}
                                    />
                                </div>
                            </div>

                            {/* Medio 2 */}
                            <div className='w-full mt-5 mb-6 bg-blue-50 rounded-lg p-5 print:hidden'>
                                <p className='text-xl font-bold'>Medio de Pago 2</p>
                                <div className='rounded-lg pt-2 sm:w-1/2'>
                                    {(medios || [])
                                        .filter(item => item.id !== '7' && item.id !== medio1)
                                        .map((item) => (
                                            <label key={item.id} className="flex items-center gap-2 py-1">
                                                <input
                                                    type="radio"
                                                    name="medioPago2"
                                                    value={item.id}
                                                    checked={medio2 === item.id}
                                                    onChange={() => setMedio2(item.id)}
                                                />
                                                <span>{item.descripcion}</span>
                                            </label>
                                        ))}
                                    <label className="block text-gray-800 mt-3" htmlFor='importe2'>Importe Medio 2</label>
                                    <input
                                        type='text'
                                        className='p-2 rounded border border-gray-300 w-full'
                                        value={importe2}
                                        id="importe2"
                                        onChange={(e) => setImporte2(e.target.value)}
                                    />
                                    <div className="mt-2">
                                        <p className="font-bold">Restante: {formatARS(restante)}</p>
                                        {suma !== Number(total) && (
                                            <p className="text-red-700 text-sm mt-1">La suma de importes debe ser igual al total.</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </>
                    )}

                    {/* Detalle */}
                    {pedidoSelected.pedido && (
                        <table className='w-full md:w-3/4 mx-auto'>
                            <thead>
                                <tr className='p-1 bg-blue-200 text-gray-900 text-center'>
                                    <th>#</th>
                                    <th>Producto</th>
                                    <th>Cantidad</th>
                                    <th>Precio unitario</th>
                                    <th>Subtotal</th>
                                </tr>
                            </thead>
                            <tbody>
                                {pedidoSelected.pedido.map((item, index) => (
                                    <tr key={index} className='p-2 text-center'>
                                        <td className='border border-gray-700 px-2'>{index + 1}</td>
                                        <td className='border border-gray-700 text-left pl-4'>{item.descripcion}</td>
                                        <td className='border border-gray-700'>{item.cantidad}</td>
                                        <td className='border border-gray-700'>
                                            {formatARS(parseFloat(item.preciounitario))}
                                        </td>
                                        <td className='border border-gray-700 font-semibold'>
                                            {formatARS(parseFloat(item.monto))}
                                        </td>
                                    </tr>
                                ))}
                                <tr className='border border-gray-300 p-2 text-center bg-slate-300'>
                                    <th colSpan={4}>Total</th>
                                    <th>{formatARS(total)}</th>
                                </tr>
                            </tbody>
                        </table>
                    )}
                </>
            ) : (
                <div className='bg-orange-200 p-3 rounded-lg'>
                    <p className='text-center font-bold text-3xl'>
                        {pedidoSelected.motivo}
                    </p>
                    <p className='text-center mt-3 font-bold text-2xl'>
                        {pedidoSelected.observaciones}
                    </p>
                </div>
            )}

            {/* Acciones */}
            <div className="w-full rounded-lg px-3 flex justify-center mt-10 print:hidden gap-3">
                {pedidoSelected.estado !== 7 && (
                    <>
                        <ReactToPrint
                            trigger={() => (
                                <button
                                    type="button"
                                    className="w-2/3 sm:w-1/4 flex shadow-md p-3 bg-indigo-500 text-white hover:bg-indigo-400 transition-all uppercase font-bold rounded-lg"
                                >
                                    <FaPrint className="mx-auto mt-1" />
                                    <span className="mx-auto text-center">Imprimir Comprobante</span>
                                </button>
                            )}
                            content={() => componentRef.current}
                        />
                        {!entregado && (
                            <button
                                type="button"
                                className={`w-1/4 sm:w-1/6 shadow-md p-3 text-white transition-all uppercase font-bold rounded-lg ${!confirmDisabled ? 'bg-orange-500 hover:bg-orange-400' : 'bg-orange-200 cursor-not-allowed'}`}
                                onClick={handleEntrega}
                                disabled={confirmDisabled}
                            >
                                Confirmar Entrega
                            </button>
                        )}
                    </>
                )}
                <button
                    type="button"
                    className="w-1/4 sm:w-1/6 shadow-md p-3 text-center bg-gray-500 text-white hover:bg-gray-400 transition-all uppercase font-bold rounded-lg"
                    onClick={handleVolver}
                >
                    Volver a Pedidos
                </button>
            </div>

            {/* CONTENIDO A IMPRIMIR */}
        </div>
    )
}

export default FViewPedido
